module.exports = __webpack_public_path__ + "static/media/galleryImg15.550713cf.jpg";